import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
}

export default function SEOHead({
  title,
  description,
  keywords = "",
  canonicalUrl = "",
  ogTitle = "",
  ogDescription = "",
  ogType = "website",
  ogUrl = "",
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.querySelector(`meta[property="${name}"]`) as HTMLMetaElement | null;
      }
      if (el) {
        el.setAttribute("content", content);
      }
    };

    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (link) {
        link.setAttribute("href", canonicalUrl);
      }
    }
    setMeta("og:title", ogTitle || title);
    setMeta("og:description", ogDescription || description);
    setMeta("og:type", ogType);
    if (ogUrl) setMeta("og:url", ogUrl);
    setMeta("twitter:title", ogTitle || title);
    setMeta("twitter:description", ogDescription || description);
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogUrl]);

  return null;
}